export type Language = "hu" | "en";

export function getLanguageFromPath(pathname: string): Language {
  return pathname.startsWith("/en") ? "en" : "hu";
}

export function getLocalizedPath(language: Language, hash = "") {
  return `${language === "en" ? "/en" : "/"}${hash}`;
}
